import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import RoleSelection from "./pages/RoleSelection";
import InstitutionalRegistration from "./pages/InstitutionalRegistration";
import DesignerRegistration from "./pages/DesignerRegistration";
import InvestorRegistration from "./pages/InvestorRegistration";
import DesignerPortal from "./pages/DesignerPortal";
import InvestorPortal from "./pages/InvestorPortal";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/orders" element={<Dashboard />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              
              {/* Multi-user type routes */}
              <Route path="/role-selection" element={<RoleSelection />} />
              <Route path="/register/institutional" element={<InstitutionalRegistration />} />
              <Route path="/register/designer" element={<DesignerRegistration />} />
              <Route path="/register/investor" element={<InvestorRegistration />} />
              <Route path="/designer" element={<DesignerPortal />} />
              <Route path="/investor" element={<InvestorPortal />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Toaster />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
